module.exports = {"player_position":"Hodor","enemy_position":"Hodor"};